import { Container } from '@cgs/wge';
import { ApplicationGameConfig } from '@cgs/shared';
import { NumberFormatter } from '@cgs/common';
import { TRIFECTA_LAUNCH_PARAMS_TOKEN, TrifectaLaunchParamsDto } from '../models/trifecta-dto';

export class TrifectaNumberFormatter extends NumberFormatter {
  private readonly numDecimals: number;
  private readonly multiplier: number;

  constructor(container: Container) {
    super();

    const launchParams = container.resolve<TrifectaLaunchParamsDto>(TRIFECTA_LAUNCH_PARAMS_TOKEN);
    this.numDecimals = launchParams.currencyDecimals;
    this.multiplier = 1 / Math.pow(10, this.numDecimals);
  }

  public override format(value: number, numDecimals: number = this.numDecimals): string {
    return super.format(value * this.multiplier, numDecimals);
  }

  public override formatMoney(value: number, numDecimals: number = this.numDecimals): string {
    return `${ApplicationGameConfig.currency} ${this.format(value, numDecimals)}`;
  }
}
